<div [ngStyle]="{'background-color': backgroundColor}" class="information-hint-container">
    <div><mat-icon class="notranslate material-symbols-rounded">info</mat-icon></div>
    <span>{{text}}</span>
</div>
